import _ from "lodash";
import { EVENT_TYPES } from "assets/js/const/Automations";
import { I18n, Translate } from "react-redux-i18n";
import { RepresentableSteps } from "../MapperUtils";
import store from "assets/js/store";
import {
	getConnectedEdges,
	isEdge,
	isNode,
	getOutgoers,
	removeElements,
} from "react-flow-renderer";
import { getConditionsValues } from "../../../scenes/AutomationEditor/containers/Conditions/IfElse/utils/generalUtils";
import { flextree } from "d3-flextree";
import { DialogHandler } from "cakemail-ui-components/lib/react";
import { getTemplateService } from "assets/js/services/TemplateService";
import { extractRssUrl } from "assets/js/utils/rssUrlExtractor";

/**
 * A variable is represented as ${VAR_NAME} , the function gets the VAR_NAME
 * @param {*} varValue
 */
const getValudOfVariable = (varValue) => {
	let actualValue = varValue.replace(/\}$/, "");
	actualValue = actualValue.replace(/\$\{/gi, "");
	return actualValue;
};
const getValueFromIntFunction = (value) => {
	let actualValue = value.replace(/int\(/, "");
	actualValue = actualValue.replace(/\)/gi, "");
	return actualValue;
};

const getShadowsForStep = (automation, mainStepId) => {
	let shadows = [];
	convertPlanToFlatArrayOfActions(automation).forEach((route) => {
		let varValue;
		if (route.condition.or) {
			varValue = getValudOfVariable(
				route.condition.or[route.condition.or.length - 1].eq?.var
			).replace("input.data.step in ", "");
		}
		if (route.condition.eq?.var) {
			varValue = getValudOfVariable(route.condition.eq?.var).replace(
				"input.data.step in ",
				""
			);
		}
		if (varValue[0] !== "[") return false;
		const varArray = JSON.parse(varValue);
		if (varArray.includes(mainStepId) && route.condition?.eq?.value == true) {
			shadows = varArray
				.filter((e) => e != mainStepId)
				.filter(
					(v) =>
						!v.includes("_loop") &&
						!v.includes("pathA") &&
						!v.includes("pathB") &&
						!v.includes("winner")
				);
			return shadows;
		}
	});
	return shadows;
};

const uniqueId = (length = 4) => {
	return parseInt(
		Math.ceil(Math.random() * Date.now())
			.toPrecision(length)
			.toString()
			.replace(".", "")
	);
};
const getEventId = () => `event_${+uniqueId()}`;
const getNodeId = () => `n${+uniqueId()}`;
const getCoahmkarNodeId = () => `coachmark_${+uniqueId()}`;

const getEdgeId = () => `edge_${+uniqueId()}`;

const isNewEvent = (node) => {
	return node.id.includes("event_");
};

const getEndCoachmarkNode = (x, y, level) => {
	return {
		id: getCoahmkarNodeId(),
		type: "editorNode",
		data: {
			initialElement: false,
			type: "coachmark",
			baseId: "coachmark",
			selected: false,
			//level: level,
		},
		draggable: false,
		position: { x: x, y: y },
		className: "coachmarkNode",
	};
};
const helperNode = () => {
	return {
		id: getNodeId(),
		draggable: false,
		type: "editorNode",
		data: {
			type: "helper",
			baseId: "helper",
		},
		position: {
			x: 0,
			y: 0,
		},
	};
};
const deleteAllHelperNodes = (automationEvents) => {
	const helperNodes = automationEvents.filter((e) => e.data?.type == "helper");
	helperNodes.forEach((helper) => {
		automationEvents.filter((e) => {
			if (isEdge(e) && e.target == helper.id) {
				//const newEdge = { ...e };
				e.target = getOutgoers(helper, automationEvents)[0].id;
				e.data.hideAddBtn = false;
				e.id = getEdgeId();
				//newEdges.push(newEdge);
			}
		});
	});
	let updatedEvents = removeElements(helperNodes, automationEvents);
	updatedEvents = [...updatedEvents];
	return updatedEvents;
};

const addProperNameNode = (event, nodes = [], selectedNodeId, eventType) => {
	let realId = selectedNodeId;
	if (selectedNodeId.startsWith('n')) {
		realId = getRealId(eventType, selectedNodeId);
	}
	const updatedNodes = nodes?.map((node, index) => {
		if (node.id == selectedNodeId) {
			node.id = realId;
		}
		if (node.source === selectedNodeId) {
			node.source = realId;
		}
		if (node.target === selectedNodeId) {
			node.target = realId;
		}
		return { ...node };
	});
	return [updatedNodes, realId];
};

export const getRealId = (eventType, selectedNodeId) => {
	switch (eventType) {
		case EVENT_TYPES.CONDITION_IFELSE:
			return selectedNodeId.replace("n", "c1_");
		case EVENT_TYPES.CONDITION_DELAY:
			return selectedNodeId.replace("n", "c2_");
		case EVENT_TYPES.CONDITION_SPLIT50:
			return selectedNodeId.replace("n", "c3_");
		case EVENT_TYPES.CONDITION_FILTERSET:
			return selectedNodeId.replace("n", "c4_");
		case EVENT_TYPES.CONDITION_RSSCHECK:
			return selectedNodeId.replace("n", "c5_");
		case EVENT_TYPES.CONDITION_SWITCHCASE:
			return selectedNodeId.replace("n", "c6_");
		case EVENT_TYPES.ACTION_SENDEMAIL:
			return selectedNodeId.replace("n", "a1_");
		case EVENT_TYPES.ACTION_LOOP:
			return selectedNodeId.replace("n", "a2_");
		case EVENT_TYPES.ACTION_UPDATECONTACT:
			return selectedNodeId.replace("n", "a3_");
		case EVENT_TYPES.ACTION_UPDATECONTACTTAGS:
			return selectedNodeId.replace("n", "a4_");
		case EVENT_TYPES.ACTION_ADDCONTACT:
			return selectedNodeId.replace("n", "a5_");
		case EVENT_TYPES.ACTION_EMAILAPI:
			return selectedNodeId.replace("n", "a6_");
		case EVENT_TYPES.ACTION_RSSSTORE:
			return selectedNodeId.replace("n", "a7_");
		default:
			return selectedNodeId;

	}
};
const changeHelperNode = (event, nodes = [], selectedNodeId) => {
	let helperNode = null;
	let addNewLink = null;
	const isSwitchCase = event.baseId === "switchCase";
	const updatedNodes = nodes?.map((node, index) => {
		if (node.id == selectedNodeId) {
			if (node.data.type.includes("helper")) {
				helperNode = node;
				// Original ifElse logic: only add link if noOfLinks === 2
				// For switchCase: handle separately below
				addNewLink = !isSwitchCase && event.configs?.noOfLinks === 2;
			}
			// Merge event data with node data to preserve conditions that might have been updated
			const mergedData = {
				...node.data,
				...event,
				// Preserve conditions from node.data if they exist (they might be more up-to-date)
				conditions: node.data.conditions || event.conditions,
				eventId: event.id,
			};
			return {
				created: node.data.type.includes("helper") && true,
				...node,
				data: mergedData,
			};
		}
		if (helperNode) {
			if (node.source === helperNode.id || node.target == helperNode.id) {
				if (addNewLink && node.source === helperNode.id) {
					return {
						...node,
						type: "branchingEdge",
						data: {
							...node.data,
							hideAddBtn: false,
							branchLabel: event.configs.label1,
						},
					};
				} else
					return {
						...node,
						data: {
							...node.data,
							hideAddBtn: false,
						},
					};
			}
		}
		return { ...node };
	});
	
	// Original ifElse logic (2 branches)
	if (addNewLink) {
		const newCoachmark = getEndCoachmarkNode(0, 0);
		const newLink = {
			id: getEdgeId(),
			source: helperNode.id,
			target: newCoachmark.id,
			type: "branchingEdge",
			data: {
				hideAddBtn: false,
				branchLabel: event.configs.label2,
			},
		};
		updatedNodes.push(newCoachmark);
		updatedNodes.push(newLink);
	}
	
	// Special handling for switchCase (branches based on user-selected case count)
	if (isSwitchCase && helperNode) {
		// Use noOfLinks from configs (set from dialog) to determine number of branches
		// Dialog is mandatory, so this should always exist for new switchCase nodes
		const noOfLinks = event.configs?.noOfLinks || 
		                   helperNode.data.configs?.noOfLinks;
		
		// Generate labels dynamically based on number of conditions
		const labels = [];
		for (let i = 0; i < noOfLinks; i++) {
			labels.push(`Case ${i + 1}`);
		}
		
		// Remove the original "custom" edge created in onAdd (it's not a branchingEdge)
		// This prevents having 5 edges (1 custom + 4 branchingEdges)
		const customEdgeIndex = updatedNodes.findIndex(
			node => node.source === helperNode.id && 
			node.type === "custom"
		);
		if (customEdgeIndex !== -1) {
			updatedNodes.splice(customEdgeIndex, 1);
		}
		
		// Get all existing case branches (sorted by case number)
		const existingCaseBranches = updatedNodes
			.filter(node => 
				node.source === helperNode.id && 
				node.type === "branchingEdge" &&
				node.data.branchLabel && 
				node.data.branchLabel.startsWith("Case ")
			)
			.sort((a, b) => {
				const numA = parseInt(a.data.branchLabel.match(/\d+/)?.[0] || "0");
				const numB = parseInt(b.data.branchLabel.match(/\d+/)?.[0] || "0");
				return numA - numB;
			});
		
		// Update labels for existing branches and create missing ones
		for (let i = 0; i < noOfLinks; i++) {
			const expectedLabel = labels[i];
			const existingBranch = existingCaseBranches[i];
			
			if (existingBranch) {
				// Update label if it's different
				if (existingBranch.data.branchLabel !== expectedLabel) {
					existingBranch.data.branchLabel = expectedLabel;
				}
			} else {
				// Create missing branch
				const newCoachmark = getEndCoachmarkNode(0, 0);
				const newLink = {
					id: getEdgeId(),
					source: helperNode.id,
					target: newCoachmark.id,
					type: "branchingEdge",
					data: {
						hideAddBtn: false,
						branchLabel: expectedLabel,
					},
				};
				updatedNodes.push(newCoachmark);
				updatedNodes.push(newLink);
			}
		}
		
		// Handle unlabeled branching edges (backward compatibility)
		const unlabeledEdgeIndex = updatedNodes.findIndex(
			node => node.source === helperNode.id && 
			node.type === "branchingEdge" &&
			(!node.data.branchLabel || node.data.branchLabel === "")
		);
		if (unlabeledEdgeIndex !== -1 && noOfLinks > 0) {
			updatedNodes[unlabeledEdgeIndex].data.branchLabel = labels[0];
		}
		
		// Add Default branch for switchCase - MUST be added after case branches
		// This ensures proper ordering for layout system
		if (event.configs.labelDefault) {
			const defaultCoachmark = getEndCoachmarkNode(0, 0);
			const defaultLink = {
				id: getEdgeId(),
				source: helperNode.id,
				target: defaultCoachmark.id,
				type: "branchingEdge",
				data: {
					hideAddBtn: false,
					branchLabel: event.configs.labelDefault,
				},
			};
			// Push coachmark first, then link (consistent with case branches)
			updatedNodes.push(defaultCoachmark);
			updatedNodes.push(defaultLink);
		}
	}
	
	return updatedNodes;
};
const addTriggerNode = (event, nodes = [], audience) => {
	const numberOfTriggerNodes = 2;
	let node = {};
	const id = getNodeId();
	switch (event.id) {
		case "contactTagged":
			node = {
				id: id,
				draggable: false,
				type: "editorNode",
				data: {
					...event,
					type: "trigger",
					baseId: event.id,
					id: id,
					initialElement: true,
					tags: [],
					tileTitle: event.tileTitle,
					...event.defaultValues,
				},
				position: {
					x: 0,
					y: 0,
				},
			};
			break;

		default:
			node = {
				id: id,
				draggable: false,
				type: "editorNode",
				data: {
					...event,
					type: "trigger",
					baseId: event.id,
					id: id,
					initialElement: true,
					audience: audience,
					tileTitle: event.tileTitle,
				},
				position: {
					x: 0,
					y: 0,
				},
			};

			break;
	}

	// need to organize the triggers
	// const helperTriggerNode = nodes.filter(
	// 	(n) => n.data.baseId == "helperTrigger"
	// )[0];
	// helperTriggerNode.position = {
	// 	x: (numberOfTriggerNodes + 1) * 480 - 150,
	// 	y: 0,
	// };
	const manualNode = nodes.filter((n) => n.data.baseId == "manual")[0];
	const firstEventId = nodes.filter((n) => n.source == manualNode.id)[0].target;
	nodes.push(getEdge("branchingEdge", id, firstEventId));
	//const updated = deepcopy(nodes);
	nodes.push(node);
	return { events: nodes, newId: id };
};

// const changeHelperNode = (event, nodes = []) => {
// 	let helperNode = null;
// 	return nodes?.map((node) => {
// 		if (node.data.selected) {
// 			if (node.data.type.includes("helper")) {
// 				helperNode = node;
// 			}
// 			return {
// 				created: node.data.type.includes("helper") && true,
// 				...node,
// 				data: {
// 					...event,
// 					eventId: event.id,
// 					selected: true,
// 				},
// 			};
// 		}
// 		if (helperNode) {
// 			if (node.source === helperNode.id || node.target == helperNode.id) {
// 				return {
// 					...node,
// 					data: {
// 						...node.data,
// 						hideAddBtn: false,
// 					},
// 				};
// 			}
// 		}

// 		return { ...node };
// 	});
// };
const constructEventObject = (event, id = null, params) => {
	let options = {};
	const eventType = getEventType(event.type, event.id);

	// Prepare default values based on event type
	switch (eventType) {
		case EVENT_TYPES.TRIGGER_SUBSCRIBED:
			options.audience = {
				list_id: params.listId,
			};
			break;

		case EVENT_TYPES.CONDITION_DELAY:
			options.directValue = params.delay;
			break;

		case EVENT_TYPES.ACTION_LOOP:
			options = params;
			break;

		case EVENT_TYPES.ACTION_UPDATECONTACT:
		case EVENT_TYPES.ACTION_UPDATECONTACTTAGS:
			options = params;
			break;

		case EVENT_TYPES.ACTION_EMAILAPI:
			options.sender = params.sender;
			options.content = params.content;
			options.thumbnailUrl = params.thumbnailUrl;
			options.isEmailEdited = params.isEmailEdited;
			options.contact_id = params.contact_id;
			options.list_id = params.list_id;
			options.tags = params.tags;
			break;

		case EVENT_TYPES.ACTION_RSSSTORE:
			options.template_id = params.template_id;
			options.rss_urls = params.rss_urls;
			break;

		case EVENT_TYPES.CONDITION_RSSCHECK:
			options.template_id = params.template_id;
			options.rss_urls = params.rss_urls;
			options.op = params.op;
			options.minNewItems = params.minNewItems;
			break;

		case EVENT_TYPES.ACTION_SENDEMAIL:
			options.email = params.email
				? { ...params.email, sender: { id: params.senderId } }
				: null;
			options.condition = params.condition;
			options.thumbnailUrl = params.thumbnailUrl;
			options.isEmailEdited = params.isEmailEdited;
			break;
	}

	const result = {
		...event,
		actionName: params.actionName,
		baseId: event.id,
		id: id || getEventId(),
		...options,
	};

	// For switchCase, set noOfLinks in configs from params.caseCount
	if (event.id === "switchCase" && params.caseCount) {
		result.configs = {
			...event.configs,
			noOfLinks: params.caseCount,
		};
	}

	return result;
};

const getNodeYValue = (events, nodeIndex) => {
	let nodeHeights = events.map((e, index) => {
		if (nodeIndex > index) {
			if (e.data.baseId === "sendEmail" || e.data.baseId === "emailAPI") return 180;
			else return 110;
		} else {
			return 0;
		}
	});
	nodeHeights = nodeHeights.reduce((x, y) => x + y);
	nodeHeights = nodeHeights + nodeIndex * 100;
	return nodeHeights;
};
const getEventType = (type, id) => {
	return `${type.toUpperCase()}_${id?.toUpperCase()}`;
};
const getStatsStepName = (conditionValue, value) => {
	return `${conditionValue}${value}`;
};

const getNextTarget = (connectedEdges, allEvents) => {
	if (connectedEdges[0].target.includes("coachmark_")) {
		return "end";
	} else {
		return connectedEdges[0].target;
	}
	// TODO : Need to improve how the valid stats for this to work properly
	// else if (
	// 	conntectedEvent.data.baseId == "ifElse" &&
	// 	conntectedEvent.data.conditions.conditions.length > 0
	// ) {
	// 	const value = getConditionsValues(
	// 		conntectedEvent.data.conditions.conditions[0],
	// 		conntectedEvent.id
	// 	)[0];
	// 	if (value) return getStatsStepName(conntectedEvent.id, "0");
	// 	else {
	// 		return connectedEdges[0].target;
	// 	}
	// } else {
	// 	return connectedEdges[0].target;
	// }
};
const convertSecondsToNearestUnit = (timeInSecs) => {
	if (timeInSecs % (60 * 60 * 24 * 7) == 0) {
		return `${timeInSecs / (60 * 60 * 24 * 7)} Weeks`;
	}
	if (timeInSecs % (60 * 60 * 24) == 0) {
		return `${timeInSecs / (60 * 60 * 24)} Days`;
	}
	if (timeInSecs % (60 * 60) == 0) {
		return `${timeInSecs / (60 * 60)} Hours`;
	}
	if (timeInSecs % 60 == 0) {
		return `${timeInSecs / 60} Minutes`;
	}
	return `${timeInSecs} Seconds`;
};
const convertTimeWithUnitToSeconds = (timeWithUnit) => {
	if (typeof timeWithUnit === "string" || timeWithUnit instanceof String) {
		const unit = timeWithUnit.split(" ")[1];
		const value = timeWithUnit.split(" ")[0];
		if (unit === "Weeks") {
			return value * 60 * 60 * 24 * 7;
		}
		if (unit === "Days") {
			return value * 60 * 60 * 24;
		}
		if (unit === "Hours") {
			return value * 60 * 60;
		}
		if (unit === "Minutes") {
			return value * 60;
		}
		return value;
	}
	return timeWithUnit;
};
const getDataEventsOnly = (uiEvents) => {
	return uiEvents.filter(
		(event) =>
			event.type === "editorNode" &&
			event.data.type !== "coachmark" &&
			event.data.type !== "trigger" &&
			event.data.type !== "helper"
	);
};
const getActionName = (name) => {
	return name ? name : I18n._translate("app-automations-action-default_name");
};
const getEdge = (type, sourceId, targetId, data) => {
	return {
		id: getEdgeId(),
		source: sourceId,
		target: targetId,
		type: type,
		data: {
			hideAddBtn: false,
			...data,
		},
	};
};
const getRepresentableStepFromSubAutomation = (subAutomation, type) => {
	let representableStep = subAutomation.steps.filter(
		(s) =>
			RepresentableSteps.includes(s.action) ||
			(s.action == "SubAutomation.Call" && s.args?.params?.delay)
	)[0];
	if (type == "ABTest") {
		representableStep = subAutomation.steps.filter(
			(step) => step.name == "n1234"
		)[0];
		return { ...representableStep, action: "Condition.ABTest" };
	}
	if (type == "contactTag") {
		return {
			...subAutomation.steps[0],
			action:
				subAutomation.steps[0].action != ""
					? subAutomation.steps[0].action
					: "Contact.Tag.Update",
		};
	}
	if (type == "switchCase") {
		return { ...representableStep, action: "Switch.Case" };
	}

	if (type == "filterSet") {
		return {
			...subAutomation.steps[0],
			action: "Filter.Set"
		};
	}

	if (type == "RSS_check") {
		return {
			...subAutomation.steps[0],
			action: "RSSItem.Check"
		};
	}
	if (
		representableStep.action == "SubAutomation.Call" &&
		representableStep.args.params.delay &&
		type !== "Loop" &&
		type !== "ABTest"
	) {
		return { ...representableStep, action: "Time.Sleep" };
	}
	if (type == "Split50") {
		return { ...representableStep, action: "Condition.Split50" };
	}
	if (type == "Loop") {
		representableStep = subAutomation.steps.filter(
			(s) => s.name !== "loopinit"
		)[0];
		return { ...representableStep, action: "Event.Loop" };
	}

	return representableStep;
};
const checkIfIndexNotLastElement = (index, automation) => {
	return index !== automation.main.steps.length - 1;
};
const getSubAutomationForAMainStep = (automation, step) => {
	return automation.sub_automations.filter(
		(sub) => sub.name == step.args.sub_automation
	)[0];
};
const getTargetStepId = (automation, events, valueOfNextStep) => {
	let targetRepresentableStepId = 0;
	const indexOfNextStep = automation.main.steps.indexOf(
		automation.main.steps.filter((s) => s.id == valueOfNextStep)[0]
	);
	const nextStep = automation.main.steps[indexOfNextStep];
	if (indexOfNextStep && indexOfNextStep != -1) {
		if (nextStep.action == "SubAutomation.Call")
			targetRepresentableStepId = getRepresentableStepFromSubAutomation(
				getSubAutomationForAMainStep(automation, nextStep)
			).id;
		else targetRepresentableStepId = nextStep.id;
	} else {
		// if the element is the last element, we will need to create an end coachmark and specify the new end coachmark as the target step
		const y = getNodeYValue(events, events.length);
		const endCoachmark = getEndCoachmarkNode(0, y);
		events.push(endCoachmark);
		targetRepresentableStepId = endCoachmark.id;
	}
	return targetRepresentableStepId;
};
const convertPlanToFlatArrayOfActions = (automation) => {
	let mainSteps = [];
	automation.main.steps.forEach((mainStep) => {
		if (mainStep.name.includes("router")) {
			mainSteps = [...mainSteps, ...mainStep.args.switch];
		}
	});
	return mainSteps;
};
const deleteTriggerNode = (nodes, deletedTriggerId) => { };
const getNextRepresentableElement = (el, mainSteps, automation) => {
	if (el && el.next && mainSteps.filter((s) => s.id === el.next).length > 0) {
		const nextStep = mainSteps.filter((s) => s.id === el.next)[0];
		if (nextStep.action == "SubAutomation.Call") {
			if (
				getRepresentableStepFromSubAutomation(
					getSubAutomationForAMainStep(automation, nextStep)
				)
			) {
				return nextStep.id;
			} else
				return getNextRepresentableElement(
					mainSteps.filter((e) => e.id == el.next)[0],
					mainSteps,
					automation
				);
		} else {
			if (RepresentableSteps.includes(nextStep.action)) {
				return nextStep.id;
			} else
				return getNextRepresentableElement(
					mainSteps.filter((e) => e.id == el.next)[0],
					mainSteps,
					automation
				);
		}
	} else {
		if (!el?.next) return null;
		else
			return getNextRepresentableElement(
				mainSteps.filter((e) => e.id == el.next)[0],
				mainSteps,
				automation
			);
	}
};
import deepcopy from "deepcopy";
import { object } from "prop-types";

const orderEvents = (events) => {
	const orderedEvents = [];
	const triggerNode = events.filter((e) => e.baseId == "subscribe")[0];
	orderedEvents.push(triggerNode);
	const orderConnectedNodes = (event) => {
		getOutgoers(event, events)[0]((e) => {
			const connectedEdge = getConnectedEdges(
				events.filter((node) => isNode(node)),
				events.filter((node) => isEdge(node))
			).filter((edge) => edge.source == event.id);
			if (connectedEdge[0].type == "custom") {
				orderedEvents.push(e);
			} else {
			}
		});
	};
};
const layoutTriggers = (triggerNodes) => {
	const middle = triggerNodes.length / 2;
	Array.prototype.move = function (from, to) {
		this.splice(to, 0, this.splice(from, 1)[0]);
	};
	const indexofManual = triggerNodes
		.map((e) => e.data.baseId)
		.indexOf("manual");
	triggerNodes.move(indexofManual, triggerNodes.length - 1);

	triggerNodes.move(
		triggerNodes.map((e) => e.data.type).indexOf("helperTrigger"),
		triggerNodes.length - 2
	);
	const differenceBetweenNodes = 630;
	const updatedTriggers = [
		...triggerNodes.map((node, index) => {
			let x = 0;
			if (middle % 1 != 0) {
				if (index + 1 == Math.ceil(middle)) {
					x = 0;
				} else {
					if (index + 1 < Math.ceil(middle)) {
						x = (Math.ceil(middle) - index - 1) * differenceBetweenNodes * -1;
					} else if (index + 1 > Math.ceil(middle)) {
						x = (index + 1 - Math.ceil(middle)) * differenceBetweenNodes;
					}
				}
			} else {
				if (index + 1 <= middle) {
					x =
						(Math.ceil(middle) - index) * differenceBetweenNodes * -1 +
						differenceBetweenNodes / 2;
				} else if (index + 1 > middle) {
					x =
						(index + 1 - Math.ceil(middle)) * differenceBetweenNodes -
						differenceBetweenNodes / 2;
				}
			}
			return {
				...node,
				position: {
					x: x,
					y: 0,
				},
			};
		}),
	];

	return updatedTriggers;
};
const layoutedEvents = (events, addPadding) => {
	var data = {
		nodes: events.filter((e) => isNode(e)),
		links: events.filter((e) => isEdge(e)),
	};

	let tree = (function (object) {
		var o = {},
			children = {};
		const paddingValue = 36;
		object.nodes.forEach(function (a, i) {
			o[a.id] = {
				id: a.id,
				name: a.id,
				size: [
					addPadding ? 480 + paddingValue : 480,
					(a.data.baseId == "sendEmail" || a.data.baseId == "emailAPI")
						? addPadding
							? 366 + paddingValue
							: 366
						: a.data.baseId == "abTest"
							? 450 + paddingValue
							: a.data.baseId == "coachmark"
								? 30
								: addPadding
									? 289 + paddingValue
									: 289,
				],
			};
		});

		object.links.forEach(function (a) {
			o[a.target].parent = o?.[a.source]?.id || "";
			o[a.source].children = o?.[a.source]?.children || [];
			o[a.source].children.push(o?.[a.target]);
			children[a.target] = true;
		});

		return Object.keys(o)
			.filter(function (k) {
				return !children[k];
			})
			.map(function (k) {
				return o[k];
			});
	})(data);
	const updatedEvents = deepcopy(events);
	let orderedEvents = [];
	var traverse = function (current) {
		//process current node here
		if (!current.children) return;
		current.children.forEach((child, index) => {
			const element = updatedEvents.filter((e) => e.id == child.data.id)[0];
			element.position.x = child.x;

			element.position.y =
				element.data.baseId == "coachmark" ? child.y - 8 : child.y;
			if (orderedEvents.filter((e) => e.id == element.id).length == 0)
				orderedEvents.push(element);
			// check if any of the elements has two parents
			if (data.links.filter((l) => l.target == element.id).length > 1) {
				let xxx = 0;
				data.links
					.filter((l) => l.target == element.id)
					.forEach((l) => {
						if (orderedEvents.filter((e) => e.id == l.source)[0]) {
							xxx =
								xxx +
								orderedEvents.filter((e) => e.id == l.source)[0].position.x;
						}
					});
				element.position.x = xxx / 2;
			}
			//if(orderedEvents.filter(e=>e.id==child.data.id).length==0)
			traverse(child);
		});
	};
	const treemap = flextree();
	treemap.spacing((nodeA, nodeB) => {
		return nodeA.path(nodeB).length + 210;
	});
	let nodes = treemap.hierarchy(tree[0], (d) => d.children);

	nodes = treemap(nodes);
	traverse(nodes);
	const triggerNodes = events.filter((e) => e.data.initialElement == true);

	orderedEvents = [
		//...events.filter((e) => e.data.initialElement == true),
		...layoutTriggers(triggerNodes),
		...orderedEvents,
		...updatedEvents.filter((e) => isEdge(e)),
	];

	return orderedEvents;
};
const getAllPreviousEventsByEventType = (eventId, eventType, eventValue) => {
	const events = store.getState().automations.automationEvents;
	const previousEvents = [];
	const nodes = events.filter((event) => isNode(event));
	const edges = events.filter((event) => isEdge(event));
	const getPreviousEvents = (id) => {
		if (events.filter((e) => e.id == id)?.[0]?.data?.baseId == "trigger") return;
		getConnectedEdges(nodes, edges)
			.filter((edge) => edge.target == id)
			.forEach((e) => {
				const connectedEvent = events.filter(
					(event) => event.id == e.source
				)[0];
				if (eventType) {
					if (connectedEvent.data[eventType] == eventValue) {
						previousEvents.push(connectedEvent);
					}
				} else {
					// need to make sure we skip the trigger events
					if (!connectedEvent.data.initialElement)
						previousEvents.push(connectedEvent);
				}
				getPreviousEvents(connectedEvent.id);
			});
	};
	getPreviousEvents(eventId);
	return previousEvents;
};

const getAllPreviousSendActions = (eventId) => {
	const events = store.getState().automations.automationEvents;
	const sendEmailEvents = [];
	const nodes = events.filter((event) => isNode(event));
	const edges = events.filter((event) => isEdge(event));
	const getPreviousEmails = (id) => {
		if (events.filter((e) => e.id == id)?.[0]?.data?.baseId == "trigger") return;
		getConnectedEdges(nodes, edges)
			.filter((edge) => edge.target == id)
			.forEach((e) => {
				const connectedEvent = events.filter(
					(event) => event.id == e.source
				)[0];
				if (connectedEvent.data.baseId == "sendEmail" || connectedEvent.data.baseId == "emailAPI") {
					sendEmailEvents.push(connectedEvent);
				}
				getPreviousEmails(connectedEvent.id);
			});
	};
	getPreviousEmails(eventId);
	return sendEmailEvents;
};
const softRemoveElements = (elementsToRemove, elements) => {
	var nodeIdsToRemove = elementsToRemove.map(function (n) {
		return n.id;
	});
	return elements.filter(function (element) {
		var edgeElement = element;
		if (
			nodeIdsToRemove.includes(element.id) ||
			nodeIdsToRemove.includes(edgeElement.target) ||
			nodeIdsToRemove.includes(edgeElement.source)
		) {
			edgeElement.deleted = true;
		}
		return true;
	});
};

const handleRssUrlExtraction = async (automationEvents, params) => {
	const checkIfEmailAPITemplateWithRSS = automationEvents.find((e) => {
		return e.data.baseId === "emailAPI";
	});

	if (checkIfEmailAPITemplateWithRSS) {
		if (checkIfEmailAPITemplateWithRSS?.data?.rss_urls) {
			params.rss_urls = checkIfEmailAPITemplateWithRSS?.data?.rss_urls;
		}
		else if (checkIfEmailAPITemplateWithRSS.data?.content?.template?.id) {
			return new Promise((resolve, reject) => {
				getTemplateService(
					{ id: checkIfEmailAPITemplateWithRSS.data?.content?.template?.id },
					(data) => {
						params.rss_urls = extractRssUrl(data.data.content.json);
						resolve(params);
					},
					() => {
						DialogHandler.show({
							type: "error",
							title: <Translate value="app-general-error-template-get" />,
						});
						reject(new Error("Failed to get template"));
					}
				);
			});
		}
	}

	return params;
};
export {
	addProperNameNode,
	constructEventObject,
	getEventType,
	getEndCoachmarkNode,
	getNodeId,
	getEdgeId,
	isNewEvent,
	getNodeYValue,
	changeHelperNode,
	convertTimeWithUnitToSeconds,
	convertSecondsToNearestUnit,
	getDataEventsOnly,
	getActionName,
	getEdge,
	getRepresentableStepFromSubAutomation,
	getTargetStepId,
	getNextRepresentableElement,
	helperNode,
	getStatsStepName,
	getNextTarget,
	layoutedEvents,
	getAllPreviousSendActions,
	getConditionsValues,
	convertPlanToFlatArrayOfActions,
	softRemoveElements,
	getShadowsForStep,
	getValudOfVariable,
	deleteAllHelperNodes,
	getAllPreviousEventsByEventType,
	getValueFromIntFunction,
	addTriggerNode,
	handleRssUrlExtraction
};
